<mat-card *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      <mat-card-title class="fs-5 mb-0">
        Latest abuse reports
      </mat-card-title>
      <button mat-button color="primary" [routerLink]="['/activity','all-abuse']" [skipLocationChange]="true">See more</button>
    </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table class="abuse-report-table" [columnHeaders]="tableDisplayColumns" [dataSource]="reportList"
        [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
      </sm-data-table>
    </div>
  </mat-card>
  <div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>
  
  <ng-template #menuTemplate let-value>
    <button mat-menu-item (click)="viewDetails(value)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">email</mat-icon>
      <span>Send message</span>
    </button>
    <button mat-menu-item (click)="blockReported(value)" *ngIf="value.adminStatus === 0 || value.adminStatus === 1">
      <mat-icon class="material-icons-outlined">app_blocking</mat-icon>
      <span>Block content</span>
    </button>
    <button mat-menu-item (click)="unblockReported(value)" *ngIf="value.adminStatus === 9">
      <mat-icon class="material-icons-outlined">lock_open</mat-icon>
      <span>Unblock content</span>
    </button>
  </ng-template>
